import { Track } from '@/services/track'
import { Control, Controller } from '@tempots/beatui'
import { ProseMirrorMarkdownInput } from '@tempots/beatui/prosemirror'
import { attr, Fragment } from '@tempots/dom'

export type WriteUpPanelOptions = {
  controller:
    | Controller<string | null | undefined>
    | Controller<string | undefined>
}

export function WriteUpPanel({ controller }: WriteUpPanelOptions) {
  return Control(
    o =>
      Fragment(
        attr.class('h-full overflow-hidden whitespace-pre-wrap'),
        ProseMirrorMarkdownInput({
          ...o,
          showToolbar: true,
          preserveLineBreaks: true,
          placeholder: 'Add cover page text here…',
        })
      ),
    {
      triggerOn: 'input',
      // The panel stays mounted while hidden behind its tab, so autofocus
      // at mount would steal focus into an invisible editor.
      autofocus: false,
      controller: controller as Controller<string | null | undefined>,
      onChange: v => {
        Track.fieldInput({
          section: 'main',
          field_name: 'writeup',
          new_value: (v ?? '').slice(0, 200),
        })
      },
    },
    attr.class('h-full overflow-hidden')
  )
}
